import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { InputBase } from '@mui/material';
import { FaEdit, FaEnvelope } from 'react-icons/fa';
import { IoCloseSharp } from 'react-icons/io5';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import {
  AiOutlineFileExcel, AiOutlinePlus
} from 'react-icons/ai';
import Select from 'react-select';
import { sendPartnerDetails, serviceProviderList } from '../../Services/Utils/ServiceProviderApis';
import { notifySet, ServiceProviderFilterSet } from '../../Services/Actions/CommonActions';
import { fromEpochToDate, isEmpty } from '../../Services/config/globals';
import { downloadXL } from '../../Services/Utils/FileApis';
import '../../assets/css/react-select.css';
import { UseStyles } from '../../components/TableStyles/tableSX';
import categoriesDropDownList from '../Categories/categoriesDropDownList';
import { selectOptionLabel, selectStyles } from '../RequestStartUp/RequestStartUpList';

function ServiceProviderMaster() {
  const dispatch = useDispatch();
  const classes = UseStyles();
  const filter = useSelector((state) => state.serviceProviderFilter);

  const options = [
    { id: 1, value: 'Pending', label: 'Pending' },
    { id: 2, value: 'Approved', label: 'Approved' },
    { id: 3, value: 'Rejected', label: 'Rejected' },
  ];

  // table pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [listRecordSize, setListRecordSize] = useState(0);
  const onPageChange = (event, newPage) => {
    setPage(newPage);
    const newOffset = (newPage * rowsPerPage) % listRecordSize;
    setItemOffset(newOffset);
  };
  const handleChangeRowsPerPage = (event) => {
    setrowsPerPage(event.target.value);
  };

  const [serviceProvider, setServiceProvider] = useState([]);

  useEffect(() => {
    serviceProviderListView();
  }, [itemOffset, rowsPerPage, filter]);

  function serviceProviderListView() {
    const params = {
      start: itemOffset,
      recordSize: rowsPerPage,
    };
    const data = {
      status: {
        id: filter?.status?.id,
      },
      categoryView: {}
    };
    if (!isEmpty(inputValue)) {
      data.fullTextSearch = inputValue;
    }
    if (!isEmpty(filter?.category)) {
      data.categoryView = {
        id: filter?.category?.id
      };
    }

    serviceProviderList(data, params).then((res) => {
      if (res.status === true) {
        setServiceProvider(res.list);
        setListRecordSize(res.records);
      } else if (res.status === -1) {
        setServiceProvider([]);
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  }
  const handleChange = (selected) => {
    dispatch(ServiceProviderFilterSet({ status: selected, category: filter?.category }));
  };

  const downloadFile = () => {
    const data = {
      status: {
        id: filter?.status?.id
      },
      categoryView: {}
    };
    if (!isEmpty(inputValue)) {
      data.fullTextSearch = inputValue;
    }
    if (!isEmpty(filter?.category)) {
      data.categoryView = {
        id: filter?.category?.id
      };
    }
    downloadXL('service-provider', data).then((res) => {
      if (res.hasError === false) {
        dispatch(notifySet({ type: 'success', message: res.message }));
      } else if (res.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  // search startup
  const [inputValue, setInputValue] = useState('');
  const handleClickSearchBar = () => {
    serviceProviderListView();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      serviceProviderListView();
    }
  };

  const sendDetails = (id) => {
    sendPartnerDetails({ id }).then((res) => {
      if (res.hasError === false) {
        dispatch(notifySet({ type: 'success', message: res.message }));
      } else if (res.hasError === true) {
        dispatch(notifySet({ type: 'error', message: res.message }));
      }
    });
  };

  return (
    <div>
      <div className="title-con">
        <div className="row align-items-center">
          <div className="col-sm-12 col-md-12 col-lg-3">
            <div className="title-left-con">
              <h6>Service Partners</h6>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-9">
            <div className="title-right-con list-ul-con">
              <ul>
                <li style={{ width: '250px' }}>
                  <Select
                    options={categoriesDropDownList()}
                    value={filter.category}
                    className="react-select__container"
                    onChange={(e) => { dispatch(ServiceProviderFilterSet({ status: filter?.status, category: e })); }}
                    isClearable="true"
                    placeholder="Category"
                    isSearchable={false}
                    getOptionLabel={selectOptionLabel}
                    styles={selectStyles}
                  />
                </li>
                <li style={{ width: '200px' }}>
                  <Select
                    options={options}
                    onChange={handleChange}
                    defaultValue={filter?.status}
                    isSearchable={false}
                  />
                </li>
                <li style={{ minWidth: '200px' }}>
                  <div>
                    <Paper
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: 'auto',
                      }}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="search"
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e)}
                        value={inputValue}
                      />
                      {inputValue ? <IoCloseSharp onClick={() => setInputValue('')} /> : ''}
                      <IconButton
                        type="button"
                        sx={{ p: '10px' }}
                        aria-label="search"
                        onClick={handleClickSearchBar}
                      >
                        <SearchIcon />
                      </IconButton>
                    </Paper>
                  </div>
                </li>
                <li>
                  <Link
                    className={`addcircle excel${isEmpty(serviceProvider) ? ' disabled' : ''}`}
                    title={isEmpty(serviceProvider) ? 'Empty Data' : 'Download data in XL format'}
                    onClick={!isEmpty(serviceProvider) ? downloadFile : () => {}}
                  >
                    <AiOutlineFileExcel />
                  </Link>
                </li>
                <li>
                  <Link
                    className="addcircle"
                    to="/add-service-provider"
                  >
                    <AiOutlinePlus />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {isEmpty(serviceProvider) && <p className="text-center" style={{ marginTop: '100px' }}>No service partner found</p> }
      {!isEmpty(serviceProvider) && (
        <div>
          <Paper sx={{ overflow: 'hidden', marginTop: '30px' }}>
            <TableContainer
              component={Paper}
              className="tableContainer"
              sx={{ maxHeight: 730, marginRight: 'auto' }}
            >
              <Table
                stickyHeader
                className={classes.root}
              >
                <TableHead>
                  <TableRow>
                    <TableCell width={60}>No.</TableCell>
                    <TableCell>Partner Name</TableCell>
                    <TableCell>Category</TableCell>
                    {/* <TableCell>Web Site</TableCell>
                      <TableCell>Estimated Perks</TableCell> */}
                    <TableCell>Partner PoC Details</TableCell>
                    <TableCell width={150}>Create Date</TableCell>
                    <TableCell width={100}>Status</TableCell>
                    {/* <TableCell>Disable</TableCell> */}
                    <TableCell width={100}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {serviceProvider.map((data, key) => (
                    <TableRow
                      key={key}
                      hover
                      tabIndex={-1}
                      className="muiTableRow"
                    >
                      <TableCell>{key + itemOffset + 1}</TableCell>
                      <TableCell>{data.name}</TableCell>
                      <TableCell>{data.categoryView.name}</TableCell>
                      {/* <TableCell>{data.website}</TableCell>
                        <TableCell>{data.estimatedPerks}</TableCell> */}
                      <TableCell>
                        {data.pocName}
                        <br />
                        {data.pocEmail}
                        <br />
                        {data.pocMobile}
                      </TableCell>
                      <TableCell>{fromEpochToDate(data.createDate)}</TableCell>
                      <TableCell>{data.status.value}</TableCell>
                      {/* <TableCell>
                          <label className={`${styles.switch}`}>
                            <input
                              type="checkbox"
                              id="Btn"
                              className={`${styles['switch-input']}`}
                              readOnly
                              checked={data.active}
                            />
                            <span
                              className={`${styles.slider} ${styles['slider-round']}`}
                            />
                          </label>
                        </TableCell> */}
                      <TableCell>
                        <Link to={`/edit-service-provider/${data.id}`}>
                          <FaEdit style={{ color: 'black', fontSize: '20px' }} />
                        </Link>{' '}
                        &nbsp;
                        <Link
                          to="#"
                          onClick={() => sendDetails(data.id)}
                        >
                          <FaEnvelope style={{ color: 'black', fontSize: '20px' }} />
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 20]}
              component="div"
              count={listRecordSize}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={onPageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="tablepaginationcon"
            />
          </Paper>
        </div>
      )}
    </div>
  );
}

export default ServiceProviderMaster;
